import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {useLocation} from "react-router-dom";

export default function InstallationVehicle() {

    const job = useLocation().state

    return (
        <div>
            <AuthenticatedTemplate>
                <div className={"title-container"}>
                    <h1>Vehicle #? Installation for: {job.name}</h1>
                </div>
                <div className={"page-container"}>
                    <div className={"page-section"}>

                        <h2>Assigned Installers</h2>

                        installers information here

                    </div>
                    <div className={"page-section"}>

                        <h2>Documentation</h2>

                        documentation information here

                        <div className={"btn-row"}>
                            <button className="btn btn-primary">Upload Pre-Installation Photos</button>
                            <button className="btn btn-primary">Upload Post-Installation Photos</button>
                        </div>

                    </div>
                    <div className={"page-section"}>

                        <h2>Designs</h2>

                        design carousel component here

                    </div>
                </div>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>You are trying to view job details while signed out. Please sign in to continue.</p>
            </UnauthenticatedTemplate>
        </div>
    );
}
